import React, { useState } from 'react';
import { Languages } from 'lucide-react';

/**
 * Reusable form field. When `onTranslate` is provided, shows a small "Traduci"
 * button that calls the parent to fill this field from an Italian source value.
 */
export const Field = ({ label, value, onChange, textarea = false, onTranslate, translateDisabled }) => {
  const [busy, setBusy] = useState(false);

  const handleTranslate = async () => {
    if (!onTranslate || busy) return;
    setBusy(true);
    try {
      await onTranslate();
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="block">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] font-bold text-black/50 uppercase tracking-widest">{label}</span>
        {onTranslate && (
          <button
            type="button"
            onClick={handleTranslate}
            disabled={busy || translateDisabled}
            data-testid="field-translate-btn"
            title="Traduci dall'italiano"
            className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-black/50 hover:text-black disabled:opacity-30 disabled:cursor-not-allowed transition"
          >
            <Languages size={12} />
            {busy ? '...' : 'Traduci'}
          </button>
        )}
      </div>
      {textarea ? (
        <textarea
          rows={2}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-lg border-[1.5px] border-black/15 bg-white px-3 py-2 focus:outline-none focus:border-black text-sm"
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-lg border-[1.5px] border-black/15 bg-white px-3 py-2 focus:outline-none focus:border-black text-sm"
        />
      )}
    </label>
  );
};

export default Field;
